import LoginRedirectCheck from 'components/LoginRedirectCheck';
import { RouteObject } from 'react-router-dom';

const authenticatingRoute = (): RouteObject => ({
  path: 'authenticating',
  element: <LoginRedirectCheck />
});

export default authenticatingRoute;
